import { gql } from '@apollo/client'

const UPDATE_ALLERGEN_IMAGE_DETAILS_MUTATION = gql`
  mutation updateAllergenImageDetails(
    $id: ID!
    $data: AllergenImageDetailsInput!
  ) {
    updateAllergenImageDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      imageUrl
    }
  }
`

export default UPDATE_ALLERGEN_IMAGE_DETAILS_MUTATION
